import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from './components/header';
import Hero from './components/Hero';
import RegistrationForm from './components/RegistrationForm';
import Footer from './components/Footer';
import Pricing from './components/Pricing';
import HowItWorks from './components/HowItWorks';
import { Analytics } from '@vercel/analytics/react';

function Home() {
  return <>
    <Header />
    <Hero />
    <RegistrationForm />
    <Footer />
  </>;
}

function PricingPage() {
  return (
    <>
      <Header />
      <Pricing />
      <Footer />
    </>
  );
}

function HowItWorksPage() {
  return (
    <>
      <Header />
      <HowItWorks />
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <Analytics />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
      </Routes>
    </Router>
  );
}

export default App;
